import { parseAccent } from "@/lib/brand";

/**
 * A thin strip of the partner's accent along the top of the app.
 *
 * Deliberately decorative: nothing sits on it, so no colour a partner chooses
 * can make anything unreadable. It is the one place an arbitrary hex is safe
 * at full strength, which is why the accent lives here rather than on buttons.
 */
export function BrandBar({ accent }: { accent: string | null | undefined }) {
	const color = parseAccent(accent);
	if (!color) return null;
	return (
		<div className="h-[3px] w-full shrink-0" style={{ background: color }} />
	);
}
